<div class="header">
  <div class="brand"><img src="assets/images/logo.png" alt=""></div>
  <div>
    @if (userDetails) {
      <div class="profile" (click)="goToUrl()">
        <div>
          @if (userDetails.profileImage) {
            <img [src]="userDetails.profileImage" class="profile-image">
          }
          @if (!userDetails.profileImage) {
            <div class="profile-image"></div>
          }
        </div>
        <div>
          <div>{{userDetails.firstName}} {{userDetails.lastName}}</div>
          <div class="text-secondary">{{userDetails?.email}}</div>
          <div class="text-secondary">GallopCash: {{getGallopCash()| currency}}</div>
        </div>
      </div>
    }
    <div class="signout" style="margin-left: 45px;">
      @if (userDetails) {
        <div (click)="signOut()">Logout</div>
      }
    </div>
  </div>


  @if (!userDetails) {
    <div class="signin" (click)="signin()">Sign In</div>
  }
</div>